import actions from '@/store/modules/detail/actions.js'
import getters from '@/store/modules/detail/getters.js'
import mutations from '@/store/modules/detail/mutations.js'

/**
 * @returns {object}
 */
const getDefaultState = () => ({
  details: []
})

export default {
  actions,
  getters,
  mutations,
  state: getDefaultState()
}

export { getDefaultState }
